import { Box, Button, useMediaQuery } from "@mui/material";
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
import React, { useState } from "react";
import Slider from "react-slick";
import { enquireNowGTMCTAClick } from "../../util/gtmutil";
import StaticOutlineButton from "../Buttons/StaticOutlineBtn";
import auth from "../Layout/util/auth";
import Popup from "../Popup";
import ReturnCalculator from "../RetrunCalculator/index";

const useStyles = makeStyles((theme) => ({
  HowWork__section: {
    padding: "0 0 0px 0",
    borderRadius: "10px",
    "@media (max-width:1024px)": {
      paddingBottom: "60px",
    },
    "@media (max-width:767px)": {
      paddingBottom: "60px",
    },

    "& .HowWork__box": {
      padding: "1px",
      transition: "all 0.5s ease",

      "& .under__box": {
        backgroundColor: "#0C091B",
        borderRadius: "10px",
        padding: "30px",
        "& span": {
          height: "56px",
          width: "56px",
          backgroundColor: "#fff",
          borderRadius: "4px",
          display: "inline-block",
          fontSize: "24px",
          color: "#07090D",
          textAlign: "center",
          padding: "10px",
          fontWeight: "bold",
          marginBottom: "30px",
          transition: "all 0.5s ease",
        },
        "& h4": {
          color: "#fff",
          fontSize: "25px",
          marginBottom: "20px",
          fontWeight: "bold",
          "@media (max-width:480px)": {
            fontSize: "19px",
            fontWeight: "700",
          },
        },
        "@media (max-width:767px)": {
          height: "388px !important",
        },
        "@media (max-width:360px)": {
          padding: "20px",
        },
      },
    },
    "& .slick-list": {
      paddingLeft: "0 !Important",
    },

    "& .slick-dots": {
      position: "absolute",
      bottom: "-38px",
      right: "-30px",
      width: "auto",
      "@media (max-width:1024px)": {
        right: "0",
        left: "0",
      },
      "@media (max-width:767px)": {
        right: "0",
        left: "0",
      },

      "& li": {
        listStyle: "none",
        margin: "5px 0",
        display: "block",
        height: "15px",
        "@media (max-width:1024px)": {
          display: "inline-block",
        },
        "@media (max-width:767px)": {
          display: "inline-block",
        },
      },

      "& button": {
        borderRadius: "50%",
        width: "12px",
        height: "12px",
        border: "none",
        border: "1px solid #fff",
        textIndent: "-9999px",
        outline: "0",
        "&:before": {
          backgroundColor: "#fff !important",
          borderRadius: "100%",
          width: "12px",
          height: "12px",
          opacity: "0",
        },
      },
    },
  },
  paragraph: {
    fontSize: "14px !important",
    color: "#fff",
  },
  howit__workSection: {
    position: "relative",

    "& h2": {
      fontWeight: "800",
      fontSize: "200px",
      color: "#0C091B",
      background:
        "linear-gradient(45deg, rgba(225, 64, 132, 1) 0%, rgba(52, 84, 250, 1) 47%, rgba(84, 181, 187, 1) 80%)",
      "-webkit-background-clip": "text",
      "-webkit-background-clip": "text",
      "background-clip": "text",

      width: "100%",
      textAlign: "center",
      textTransform: "uppercase",
      "-webkit-text-stroke": "4px transparent",
      "@media (max-width:1024px)": {
        display: "none",
      },
      "@media (max-width:767px)": {
        display: "none",
      },
    },
    "& h3": {
      color: "#fff",
      fontSize: "35px",
      fontWeight: "bold",
      position: "absolute",
      top: "43px",
      left: "0",
      right: "0",
      fontWeight: "700",
      "@media (max-width:1024px)": {
        position: "inherit",
        top: "inherit",
        fontSize: "35px",
        marginBottom: "30px",
      },
      "@media (max-width:767px)": {
        position: "inherit",
        top: "inherit",
        fontSize: "25px",
        marginBottom: "30px",
      },
    },
  },
  fan__workSection: {
    position: "relative",
    zIndex: "1",
    bottom: "89px",
    "@media (max-width:1024px)": {
      bottom: "0",
    },
    "@media (max-width:767px)": {
      bottom: "0",
    },
  },
  Influencer__FanHeading: {
    "& h3": {
      fontSize: "35px",
      color: "#fff",
      fontWeight: "700",
      marginBottom: "40px",
    },
  },

  fan__howitworkBottom: {
    maxWidth: "47%",
    margin: "30px auto 0",
    textAlign: "center",
    "@media (max-width:767px)": {
      maxWidth: "100%",
    },

    "& .Custome__buttonFan": {
      margin: "auto",
      transition: "all 0.5s ease",
      borderRadius: "100px",
      backgroundImage:
        "linear-gradient(to right, #E14084 0%, #3454FA 53.16%, #54B5BB 100%)",
      marginTop: "10px",
      padding: "2px",
      border: "none",
      "& span": {
        backgroundColor: "#0c091b",
        fontSize: "16px",
        color: "#fff",
        width: "198px",
        height: "60px",
        borderRadius: "100px",
        display: "inline-block",
        margin: "auto",
        alignItems: "end",
        textAlign: "center",
        padding: "18px 0",
        "&:hover": {
          backgroundImage:
            "linear-gradient(to right, #E14084 0%, #3454FA 53.16%, #54B5BB 100%)",
          boxShadow: "0px 0px 31px 3px #3659f6",
        },
      },
      "&:hover": {
        backgroundImage: "none",
        backgroundColor: "transparent",
      },
    },
    "& .linebreak": {
      backgroundImage:
        "linear-gradient(to right, #E14084 0%, #3454FA 53.16%, #54B5BB 100%)",
      height: "5px",
      width: "100%",
      borderRadius: "100px",
    },
    "& p": {
      fontSize: "14px !important",
      color: "#fff",
      margin: "30px 0",
      opacity: "0.54",
      fontWeight: "400",
    },
  },
}));

const HowWork = (props) => {
  const { songPage = false, tierData = [], version = false } = props;
  console.log("calculator conditon", props);
  const artistFanSlider = {
    dots: true,
    infinite: true,
    speed: 500,
    autoplay: false,
    slidesToShow: 1,
    arrows: false,
    slidesToScroll: 1,
    centerMode: true,
    centerPadding: "30px",
  };
  const classes = useStyles();
  const isMobile = useMediaQuery("(max-width:1024px)");
  const [calculator, setCalculator] = useState(false);
  const r = auth();

  const handleReturnCalculator = () => {
    enquireNowGTMCTAClick(
      r,
      "ctaClicks",
      "loggedIn",
      "Guest",
      "Return Calculator"
    );
    setCalculator(true);
  };
  console.log("Print calcuckuor tp opop value:", calculator);
  return (
    <Box id="Howitwork">
      <section className={classes.HowWork__section}>
        <Container maxWidth="lg">
          <Box
            className={
              props?.Influencer == "Influencer"
                ? classes.Influencer__FanHeading
                : classes.howit__workSection
            }
          >
            {props?.Influencer === "Influencer" ? (
              <></>
            ) : (
              <Typography variant="h2">Works</Typography>
            )}

            <Typography variant="h3" textAlign={"center"}>
              How it Works?
            </Typography>
          </Box>

          {isMobile ? (
            <Slider className={classes.SlickSlider} {...artistFanSlider}>
              <Grid item md={12} sx={{ paddingRight: "30px" }}>
                <Box className="HowWork__box" style={{ height: "100%" }}>
                  <Box className="under__box" style={{ height: "100%" }}>
                    <span>1</span>
                    <Typography variant="h4">Invest in Music</Typography>
                    <Typography component="p" className={classes.paragraph}>
                      Let’s say Mr. Wise invests INR 4000 to buy a Gold NFT for
                      Song A on FanTiger & gets a 0.2% royalty income share and
                      exclusive privileges
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={12} sx={{ paddingRight: "30px" }}>
                <Box className="HowWork__box" style={{ height: "100%" }}>
                  <Box className="under__box" style={{ height: "100%" }}>
                    <span>2</span>
                    <Typography variant="h4">
                      {" "}
                      How does song make money?
                    </Typography>
                    <Typography component="p" className={classes.paragraph}>
                      Song A is distributed across all streaming platforms
                      (YouTube, Spotify, Gaana, Wynk, Saavn, etc). For every
                      stream / view on these platforms, the song earns money
                      (royalty income).
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={12} sx={{ paddingRight: "30px" }}>
                <Box className="HowWork__box" style={{ height: "100%" }}>
                  <Box className="under__box" style={{ height: "100%" }}>
                    <span>3</span>
                    <Typography variant="h4">How do i make money?</Typography>
                    <Typography component="p" className={classes.paragraph}>
                      Let’s say it’s been 1 year and Song A has earned royalty
                      income of INR 50 lacs. At 0.2% share, Mr. Wise’s
                      investment would be now worth INR 10,000. Hit Songs in the
                      past have given a return as high as 2000% - 5000%.
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={12} sx={{ paddingRight: "30px" }}>
                <Box className="HowWork__box" style={{ height: "100%" }}>
                  <Box className="under__box" style={{ height: "100%" }}>
                    <span>4</span>
                    <Typography variant="h4">
                      When do i get the money?
                    </Typography>
                    <Typography component="p" className={classes.paragraph}>
                      Song A has a royalty payout period of 5 years. Mr. Wise
                      has 2 options to get the Money 1. Wait till end of Royalty
                      Period and cash out 2. Sell on FanTiger Marketplace
                      (launching soon)
                    </Typography>
                  </Box>
                </Box>
              </Grid>
            </Slider>
          ) : (
            <Box
              className={
                props?.Influencer == "Influencer"
                  ? classes.test2
                  : classes.fan__workSection
              }
              sx={{ width: "100%" }}
            >
              <Grid
                direction="row"
                container
                rowSpacing={1}
                columnSpacing={{ xs: 1, sm: 2, md: 3 }}
              >
                <Grid item md={3}>
                  <Box className="HowWork__box" style={{ height: "100%" }}>
                    <Box className="under__box" style={{ height: "100%" }}>
                      <span>1</span>
                      <Typography variant="h4">Invest in Music</Typography>
                      <Typography component="p" className={classes.paragraph}>
                        Let’s say Mr. Wise invests INR 4000 to buy a Gold NFT
                        for Song A on FanTiger & gets a 0.2% royalty income
                        share and exclusive privileges
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item md={3}>
                  <Box className="HowWork__box" style={{ height: "100%" }}>
                    <Box className="under__box" style={{ height: "100%" }}>
                      <span>2</span>
                      <Typography variant="h4">
                        How does song make money?
                      </Typography>
                      <Typography component="p" className={classes.paragraph}>
                        Song A is distributed across all streaming platforms
                        (YouTube, Spotify, Gaana, Wynk, Saavn, etc). For every
                        stream / view on these platforms, the song earns money
                        (royalty income).
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item md={3}>
                  <Box className="HowWork__box" style={{ height: "100%" }}>
                    <Box className="under__box" style={{ height: "100%" }}>
                      <span>3</span>
                      <Typography variant="h4">How do i make money?</Typography>
                      <Typography component="p" className={classes.paragraph}>
                        Let’s say it’s been 1 year and Song A has earned royalty
                        income of INR 50 lacs. At 0.2% share, Mr. Wise’s
                        investment would be now worth INR 10,000. Hit Songs in
                        the past have given a return as high as 2000% - 5000%.
                      </Typography>
                    </Box>
                  </Box>
                </Grid>

                <Grid item md={3}>
                  <Box className="HowWork__box" style={{ height: "100%" }}>
                    <Box className="under__box" style={{ height: "100%" }}>
                      <span>4</span>
                      <Typography variant="h4">
                        When do i get the money?
                      </Typography>
                      <Typography component="p" className={classes.paragraph}>
                        Song A has a royalty payout period of 5 years. Mr. Wise
                        has 2 options to get the Money 1. Wait till end of
                        Royalty Period and cash out 2. Sell on FanTiger
                        Marketplace (launching soon)
                      </Typography>
                    </Box>
                  </Box>
                </Grid>
              </Grid>

              {/* {props?.Influencer != "Influencer" && (
                <Box className={classes.fan__howitworkBottom}>
                  <StaticOutlineButton
                    buttonText="Calculate Returns"
                    handleClick={() => handleReturnCalculator()}
                  />
                  <Button
                    onClick={() => {
                      enquireNowGTMCTAClick(
                        r,
                        "ctaClicks",
                        "loggedIn",
                        "Guest",
                        "Return Calculator"
                      );
                      setCalculator(true);
                    }}
                  >
                    Calculate Returns
                  </Button>
                  <p>
                    *Disclaimer : music Investment is subject to song
                    performance risks, please exercise due caution before
                    investing. Past performance is not indicative of future
                    results.
                  </p>
                  <Box className="linebreak"></Box>
                </Box>
              )} */}
            </Box>
          )}
        </Container>
      </section>
      {calculator && (
        <Popup noCloseButton handlePopupClose={() => setCalculator(false)}>
          <ReturnCalculator
            closePopup={() => setCalculator(false)}
            tierData={tierData}
            version={version}
          ></ReturnCalculator>
        </Popup>
      )}
    </Box>
  );
};

export default HowWork;
